import ManualCatExposures from "./ManualCatExposures";
import SovCatExposures from "./SovCatExposures";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Stack } from "@mui/system";
import Component from "components/Component";
import Button from "components/common/Button";
import Disabled from "components/common/Disabled";
import { usePricing } from "components/customPricing/dnfModel1/pricingHooks";
import { useState } from "react";
import { useSelector } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as analytics from "store/analytics";

const CatExposures = () => {
  const analyticsData = useSelector(analytics.select);

  const { data: analyticsConfig } = staticDataService.useConfigQuery(
    "analytics"
  );

  const { data: catConfig } = staticDataService.useConfigQuery("cat_exposures");
  const catModelNames = Object.fromEntries(
    (catConfig?.enums?.catModels?.choices ?? [])
      .filter(({ key, name }) => !!key && !!name)
      .map(({ key, name }) => [key, name])
  );

  const [selectedCatModel, setSelectedCatModel] = useState(null);

  const { isFetching, refetch } = usePricing();

  const engine = analyticsData?.programPricing?.engine ?? null;
  const engineConfig = analyticsConfig?.engineConfig?.[engine] ?? {};
  const useMultiCatModelMode = analyticsConfig
    ? engineConfig?.useMultiCatModelMode ?? false
    : null;
  const catModels = engineConfig?.catModels ?? [];

  const catModel = selectedCatModel ?? catModels[0] ?? null;

  return (
    <Component
      title={"Cat Exposures"}
      isFetching={isFetching}
      options={
        <Stack direction={"row"} spacing={2}>
          {useMultiCatModelMode && catModels.length && (
            <FormControl variant={"filled"} size={"small"}>
              <InputLabel>{"Cat Model"}</InputLabel>
              <Select
                value={catModel}
                onChange={(e) => setSelectedCatModel(e.target.value)}
                sx={{
                  minWidth: 180,
                }}
              >
                {catModels.map((key) => {
                  return (
                    <MenuItem key={key} value={key}>
                      {catModelNames[key] ?? key}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          )}
          <Disabled ifReadOnly>
            <Button onClick={refetch} isLoading={isFetching}>
              {"Calculate"}
            </Button>
          </Disabled>
        </Stack>
      }
    >
      <Stack spacing={2}>
        <SovCatExposures catModel={catModel} />
        <ManualCatExposures
          catModel={catModel}
          useMultiCatModelMode={useMultiCatModelMode}
        />
      </Stack>
    </Component>
  );
};

export default CatExposures;
